require('slick-carousel');

const _this = {

    $dom: {
		homeHeroSlider: $('.js-home-hero-slider'),
        homeLogoSlider: $('.js-donors-slider'),
    },

    vars: {
		
	},

    init : function() {
        _this.$dom.homeHeroSlider.slick({
            slidesToScroll: 1,
			slidesToShow: 1,
			dots: true,
			arrows: true,
			autoplay: false,
			infinite: false,
            rows: 0,
            prevArrow: "<button type='button' class='slick-prev pull-left home-hero-arrow'><img src='" + theme.slider_left + "' /></button>",
			nextArrow: "<button type='button' class='slick-next pull-right home-hero-arrow'><img src='" + theme.slider_right + "' /></button>",
        });

        _this.$dom.homeLogoSlider.slick({
            slidesToScroll: 1,
			slidesToShow: 1,
			dots: false,
			arrows: false,
			autoplay: true,
			infinite: true,
            rows: 0,
            variableWidth: true
        });

        $(window).on('load resize', function() {
            if($(window).width() <= 890) {
                $('.publications-posts-wrapper').slick({
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                    infinite: false,
                    autoplay: true,
                    rows: 0,
                });
            }
        });
    },
}

export default _this;